import React from 'react'
import { bool } from 'prop-types'

import { Sidebar, WelcomeNavList } from './styled'
import renderWelcomeNav from '../renderWelcomeNav'

const WelcomeNav = ({ open, ...rest }) => (
  <Sidebar open={open} {...rest}>
    <WelcomeNavList style={{ marginTop: '6rem' }}>
      {renderWelcomeNav()}
    </WelcomeNavList>
  </Sidebar>
)

WelcomeNav.propTypes = {
  open: bool.isRequired,
}

export default WelcomeNav



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/SidebarNav/WelcomeNav.js